import { useState, useCallback } from 'react'
import { api } from '~/services/api'
import { DetailedWork } from '~/types/api'

export function useWorkDetails({ workId }: { workId: string }) {
  const [work, setWork] = useState<DetailedWork | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  const fetchWork = useCallback(async () => {
    try {
      setIsLoading(true)
      const data = await api.works.getById(workId)
      setWork(data)
      setError(null)
    } catch (err) {
      console.error('Failed to fetch work:', err)
      setError(err instanceof Error ? err : new Error('Failed to fetch work'))
    } finally {
      setIsLoading(false)
    }
  }, [workId])

  const updateVotes = useCallback((votesFor: number, votesAgainst: number) => {
    if (work) {
      setWork({
        ...work,
        votesFor,
        votesAgainst
      })
    }
  }, [work])

  return {
    work,
    isLoading,
    error,
    fetchWork,
    updateVotes
  }
} 